import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';

@Injectable({
  providedIn: 'root'
})
export class PatientAlertDataService {
  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public completeAlerts(ids: number[], timeout: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync<boolean>('PatientAlerts/CompleteAlerts', ids, timeout, false);
  }
}
